import { render, staticRenderFns } from "./SearchQuestion.vue?vue&type=template&id=35c6c9e0&"
import script from "./SearchQuestion.vue?vue&type=script&lang=js&"
export * from "./SearchQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports